export default (state = {
    fetched:false,
    images:[],
    seller:{
        addresses:[]
    },
    attributes:[],
    handling_times:[],
    shipping_delivery_options_list:[],
    pickup_from: 0,


}, action) => {

    switch (action.type) {
        case 'FETCHING_SELL_PRODUCT' :
            return {
                ...state,
                fetched:false
            };
        case 'FETCHING_SELL_PRODUCT_FAILED':
            return {
                ...state,
                fetched:0
            };
        case 'FETCH_SELL_PRODUCT' :
            return {
                ...state,
                ...action.results,
                fetched:true
            };
        case 'SELL_CHANGE_PICKUP_FROM' :
            return {
                ...state,
                pickup_from: action.pickup_from
            };

        default:
            return state;
    }
};

